import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import LoginForm from './../block/LoginForm'
import Breadcrumbs from './../block/Breadcrumbs'
import LkSidebar from './../block/LkSidebar'

import { Button, Container, Form, Modal } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import styles from './../style/Lk.module.scss'
import icon_styles from './../style/InputIcons.module.scss'

export default class Lk extends Component {

  static defaultProps = {
    cart: []
  }

  constructor(props) {
    super(props)

    this.state = {
      id: ``,
      name: ``,
      email: ``,
      phone: ``,
      password: ``,
      adres: ``,
      inn: ``,
      company: ``,
      show: false,
      modal_text: ``,
      cartCount: props.cart.reduce((total, item) => total + item.count, 0)
    }
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  submitForm = ( e ) => {
    const { id, name, email, phone, password, adres, inn, company } = this.state
    e.preventDefault()

    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'save_user_fields',
      'id': id,
      'name': name,
      'email': email,
      'phone': phone,
      'password': password,
      'adres' : adres,
      'inn' : inn,
      'company' : company
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        this.setState({
          name: response.data.fullname,
          email: response.data.email,
          phone: response.data.mobilephone,
          password: '',
          adres: response.data.address,
          inn: response.data.inn,
          company: response.data.company
        }, () => {
          this.handleShow( `Ваши данные успешно обновлены` )
        })
      } else {
        this.handleShow( `Ошибка, проверьте поля формы` )
      }
    })
  }

  change_name( value ) {
    this.setState({
      name: value
    })
  }
  change_email( value ) {
    this.setState({
      email: value
    })
  }
  change_phone( value ) {
    this.setState({
      phone: value
    })
  }
  change_password( value ) {
    this.setState({
      password: value
    })
  }
  change_adres( value ) {
    this.setState({
      adres: value
    })
  }
  change_inn( value ) {
    this.setState({
      inn: value
    })
  }
  change_company( value ) {
    this.setState({
      company: value
    })
  }

  handleShow( text ) {
    this.setState({
      show: true,
      modal_text: text
    })
  }
  handleClose() {
    this.setState({
      show: false
    }, () => {
      window.location.reload()
    })
  }

  logOut() {
    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'logout'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        location.reload()
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.authorized !== prevProps.authorized) {
      const { user } = this.props
      this.setState({
        id: user.id,
        name: user.fullname,
        email: user.email,
        phone: user.mobilephone,
        adres: user.address,
        inn: user.inn,
        company: user.company
      })
    }
  }

  render() {
    const { ajax_data, data, authorized, loading_user, user_profile_type } = this.props,
    { name, email, phone, password, adres, inn, company, show, modal_text, cartCount } = this.state

    if (loading_user) {
      return (
        <>
          <Breadcrumbs items={ajax_data.breadcrumbs} />
          <div className='w-100 d-flex align-items-center' style={{ flex: 1 }}>
            <Container className={styles.container + ' text-center'}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p className="mt-3">Загрузка данных...</p>
            </Container>
          </div>
        </>
      )
    }

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <>
              {authorized ?
                <>
                  <Breadcrumbs items={ajax_data.breadcrumbs} />
                  <div className={styles.lk_page}>
                    <Container className={styles.container}>
                      <h1>{ajax_data.pagetitle}</h1>
                      <div className={styles.lk_page_block}>
                        <LkSidebar 
                          data={data} 
                          cartCount={cartCount} 
                          logOut={() => this.logOut()} 
                          active={1}
                          user_profile_type={user_profile_type}
                        />

                        <div className={styles.lk_page_block_right}>
                          <Form className={styles.lk_page_block_right_form} onSubmit={( e ) => this.submitForm( e )}>

                            <Form.Control 
                              required 
                              name="name" 
                              className={`${styles.login_form_input} ${icon_styles.name_input}`} 
                              type="text" 
                              value={name} 
                              onChange={( e ) => this.change_name( e.target.value )} 
                              placeholder="Ваше имя" 
                            />

                            <Form.Control 
                              required 
                              name="phone" 
                              as={IMaskInput} 
                              mask="+{7} (000) 000-00-00" 
                              lazy={true} 
                              type="phone" 
                              className={`${styles.login_form_input} ${icon_styles.phone_input}`} 
                              value={phone} 
                              onChange={( e ) => this.change_phone( e.target.value )} 
                              placeholder="Номер телефона" 
                            />

                            <Form.Control 
                              name="password" 
                              className={`${styles.login_form_input} ${icon_styles.password_input}`} 
                              type="password" 
                              value={password} 
                              onChange={( e ) => this.change_password( e.target.value )} 
                              placeholder="Введите пароль" 
                            />

                            <Form.Control 
                              name="adres" 
                              className={`${styles.login_form_input} ${icon_styles.adres_input}`} 
                              type="text" 
                              value={adres} 
                              onChange={( e ) => this.change_adres( e.target.value )} 
                              placeholder="Введите адрес" 
                            />

                            {user_profile_type == `legal` &&
                              <>
                                <Form.Control 
                                  name="inn" 
                                  className={`${styles.login_form_input} ${icon_styles.inn_input}`} 
                                  type="text" 
                                  value={inn} 
                                  onChange={( e ) => this.change_inn( e.target.value )} 
                                  placeholder="ИНН" 
                                />

                                <Form.Control 
                                  name="company" 
                                  className={`${styles.login_form_input} ${icon_styles.company_input}`} 
                                  type="text" 
                                  value={company} 
                                  onChange={( e ) => this.change_company( e.target.value )} 
                                  placeholder="Название компании" 
                                />
                              </>
                            }

                            <Form.Control 
                              required 
                              name="email" 
                              className={`${styles.login_form_input} ${icon_styles.email_input}`} 
                              type="email" 
                              value={email} 
                              onChange={( e ) => this.change_email( e.target.value )} 
                              placeholder="Введите почту" 
                            />

                            <Button type="submit" variant={`primary`} className={styles.lk_page_block_right_form_btn + ` text-white`}>Сохранить</Button>
                            <div className={styles.lk_page_block_right_pconf}>
                              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="16" height="16" rx="8" fill="white" stroke="#1E9FF6"/>
                                <rect x="4" y="4" width="9" height="9" rx="4.5" fill="#1E9FF6"/>
                              </svg>
                              <div>Я ознакомлен и согласен с условиями <a target="_blank" href="/dogovor-ofertyi">оферты</a> и <a target="_blank" href="/privacy">политики конфиденциальности</a></div>
                            </div>
                          </Form>
                        </div>
                      </div>

                    </Container>
                  </div>
                </>
              :
                <>
                  <Breadcrumbs
                    items={[
                      {
                        id: 99,
                        pagetitle: `Вход в учетную запись`,
                        is_current: true
                      }
                    ]}
                  />
                  <LoginForm
                    ajax_data={ajax_data}
                    user_profile_type={user_profile_type}
                  />
                </>
              }
            </>
          }
        </div>
        {ajax_data != null &&
          <Modal centered show={show} onHide={() => this.handleClose()}>
            <Modal.Header closeButton>
              <Modal.Title>{ajax_data.pagetitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modal_text}</Modal.Body>
          </Modal>
        }
      </>
    )
  }
}

Lk.propTypes = {
  ajax_data: PropTypes.object,
  data: PropTypes.object,
  cart: PropTypes.array,
  user: PropTypes.object,
  authorized: PropTypes.bool,
  loading_user: PropTypes.bool,
  user_profile_type: PropTypes.string
}